import {LayoutTemplate} from "./app/pages/templates/LayoutTemplate";
import './App.css';
import './i18n'
import 'swiper/css';
import 'swiper/css/effect-cards';
import { Provider } from 'react-redux';
import { store } from './infrastructure/store/store';
import { UserProvider } from './infrastructure/context/UserContext';

function App() {
  return (
    <Provider store={store}>
      <UserProvider>
        <LayoutTemplate />
      </UserProvider>
    </Provider>
  );
}

export default App;
